export default __webpack_public_path__ + "static/media/zumzi_prietenul_casei_tale.3ea74edc.png";